module.exports = __webpack_public_path__ + "static/media/pha-kuang-clara.2ba3186c.jpg";